import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TooltipBubbleComponent } from '@app/shared/components/tooltip-bubble/tooltip-bubble.component';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { UserRepository } from '@app/shared/state/user/user.repository';

@Component({
  selector: 'slotcom-highscore-info-modal',
  templateUrl: './highscore-info-modal.component.html',
  styleUrls: ['./highscore-info-modal.component.scss'],
  standalone: true,
  imports: [TooltipBubbleComponent, TranslateModule, NavigationButtonComponent],
})
export class HighscoreInfoModalComponent {
  highscoreInfoModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private userRepo = inject(UserRepository);

  showBarText: boolean = this.userRepo.getGeoIpCountryCode() === 'ES';
  culture: string = this.userRepo.getCulture();

  closeModal() {
    this.eventManager.closeModal(
      new Modal(NonPersistedModalName.HighscoreInfoModalComponent, ModalType.View, this.highscoreInfoModalData)
    );
  }
}
